export interface DateOverlapErrorData {
    entityType: string;
    conflictingEffectiveDate: string;
    conflictingExpirationDate: string;
}

export class DateOverlapError extends Error {
    entityType: string;
    conflictingEffectiveDate: string;
    conflictingExpirationDate: string;

    constructor(data: DateOverlapErrorData) {
        super(`Date range overlaps with an existing ${data.entityType}`);
        this.entityType = data.entityType;
        this.conflictingEffectiveDate = data.conflictingEffectiveDate;
        this.conflictingExpirationDate = data.conflictingExpirationDate;
    }
}

export async function throwIfDateOverlap(response: Response): Promise<void> {
    if (response.status === 409) {
        const body = await response.json();
        throw new DateOverlapError({
            entityType: body.entityType ?? 'record',
            conflictingEffectiveDate: body.conflictingEffectiveDate ?? '',
            conflictingExpirationDate: body.conflictingExpirationDate ?? '',
        });
    }
}
